<template>
<div class="chapter">
<div class="inner_page">
<p class="tx-ctr" id="ack">I would like to thank:</p>
<p class="tx-ctr">Dave and Sarah Rizzo and Celia and Toni too and Harry, of course, for the granny flat, the piano accompaniment (Celia), the daily runway show (Toni), the inter-species welcome (Harry) and the answers to a thousand questions while I worked on this book.</p>
<p class="tx-ctr">Connie and Sheldon Berkowitz, Dick Hoenisch and Deborah Golino, Carla Thomas, Karin, Takao and Phoebe Kasuga, and all the faculty and staff of the Plant Pathology Department of UC Davis for their friendly support.</p>
<p class="tx-ctr">Spring Warren and Eileen Rendahl for their entertaining and outrageous take on life, their understanding and their instant friendship. Sally Madden for fortitude in the face of technology. To these three and also to Stella Ruiz and Katie Howard – thank you for your names.</p>
<p class="tx-ctr">My family and friends in Scotland for being so patient while I got my act together.</p>
<p class="tx-ctr">Lisa Moylett, Wonder Agent, for her steady hand on the tiller.</p>
<p class="tx-ctr">Bronwen Salter-Murison for the Dandy Gilver website – above and beyond.</p>
<p class="tx-ctr">Suzie Dooré (aka Editrix Lestrange) for the best edit ever – practically co-authoring this time. Francine Toon for her cheerful and organised way with things and for her title-generating skills. Imogen Olsen for a copy-edit that started with a shovel and ended with a scalpel. You have saved my bacon once again.</p>
<p class="tx-ctr">Marcia Markland, Bridget Hartzler and Kat Brzozowski for inducting me kindly but firmly into the ways of US publishing.</p>
<p class="tx-ctr">Neil McRoberts. Still. Kind of. No, really.</p>
<p class="tx-ctr">And thanks again, because once wasn’t enough, to Sarah Rizzo.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?622deb4b